import type { MenuCreatorCategory } from "./types";

export const getSampleData = (): MenuCreatorCategory[] => [
  {
    id: "appetizers",
    guid: "appetizers-guid",
    name: "Amuse-Bouches & Appetizers",
    order: 0,
    status: "active",
    color: "#8B5A3C",
    product_guids: [],
    product_ids: [],
    deleted_at: null,
    products: [
      {
        id: "burrata",
        name: "Burrata di Puglia",
        description:
          "Creamy burrata with heirloom tomatoes, aged balsamic, and fresh basil oil",
        price: "28.00",
        weight: "150g",
        type: "food",
        item_type: "food" as const,
        status: "active",
        slug: "burrata-di-puglia",
        bundles: null,
        additional_info: null,
        special_price: null,
        is_custom: 0,
        deleted_at: null,
        extra_limit: null,
        product_limit: null,
        color: "#8B5A3C",
        sample_image:
          "https://images.unsplash.com/photo-1571091718767-18b5b1457add?w=400&h=300&fit=crop",
        nutritional_info: {
          servingSize: { amount: 150, unit: "g" },
          calories: 320,
          macronutrients: {
            totalFat: { value: 24, unit: "g", saturatedFat: 16 },
            totalCarbohydrate: {
              value: 8,
              unit: "g",
              totalSugars: 4,
              dietaryFiber: 1,
            },
            protein: { value: 18, unit: "g" },
            sodium: { value: 420, unit: "mg" },
          },
          allergens: ["milk"],
          dietaryTags: ["vegetarian"],
        },
      },
      {
        id: "tuna-tartare",
        name: "Yellowfin Tuna Tartare",
        description:
          "Hand-cut tuna with avocado mousse, citrus vinaigrette, and crispy shallots",
        price: "32.00",
        weight: "120g",
        type: "food",
        item_type: "food" as const,
        status: "active",
        slug: "yellowfin-tuna-tartare",
        bundles: null,
        additional_info: null,
        special_price: null,
        is_custom: 0,
        deleted_at: null,
        extra_limit: null,
        product_limit: null,
        color: "#8B5A3C",
        sample_image:
          "https://images.unsplash.com/photo-1562967914-608f82629710?w=400&h=300&fit=crop",
        nutritional_info: {
          servingSize: { amount: 120, unit: "g" },
          calories: 185,
          macronutrients: {
            totalFat: { value: 8, unit: "g", saturatedFat: 2 },
            totalCarbohydrate: {
              value: 4,
              unit: "g",
              totalSugars: 1,
              dietaryFiber: 1,
            },
            protein: { value: 26, unit: "g" },
            sodium: { value: 280, unit: "mg" },
          },
          allergens: ["fish"],
          dietaryTags: ["gluten-free", "dairy-free"],
        },
      },
    ],
  },
  {
    id: "mains",
    guid: "mains-guid",
    name: "Plats Principaux",
    order: 1,
    status: "active",
    color: "#2D4A22",
    product_guids: [],
    product_ids: [],
    deleted_at: null,
    products: [
      {
        id: "wagyu-beef",
        name: "Wagyu Beef Tenderloin",
        description:
          "Grade A5 Wagyu with truffle potato purée, seasonal vegetables, and red wine jus",
        price: "85.00",
        weight: "250g",
        type: "food",
        item_type: "food" as const,
        status: "active",
        slug: "wagyu-beef-tenderloin",
        bundles: null,
        additional_info: null,
        special_price: null,
        is_custom: 0,
        deleted_at: null,
        extra_limit: null,
        product_limit: null,
        color: "#2D4A22",
        sample_image:
          "https://images.unsplash.com/photo-1546833999-b9f581a1996d?w=400&h=300&fit=crop",
        nutritional_info: {
          servingSize: { amount: 250, unit: "g" },
          calories: 650,
          macronutrients: {
            totalFat: { value: 45, unit: "g", saturatedFat: 22 },
            totalCarbohydrate: {
              value: 12,
              unit: "g",
              totalSugars: 4,
              dietaryFiber: 1,
            },
            protein: { value: 52, unit: "g" },
            sodium: { value: 580, unit: "mg" },
          },
          allergens: ["milk"],
          dietaryTags: ["gluten-free"],
        },
      },
      {
        id: "duck-confit",
        name: "Duck Leg Confit",
        description:
          "Traditional duck confit with cherry gastrique, wild mushrooms, and pommes sarladaises",
        price: "42.00",
        weight: "280g",
        type: "food",
        item_type: "food" as const,
        status: "active",
        slug: "duck-leg-confit",
        bundles: null,
        additional_info: null,
        special_price: null,
        is_custom: 0,
        deleted_at: null,
        extra_limit: null,
        product_limit: null,
        color: "#2D4A22",
        sample_image:
          "https://images.unsplash.com/photo-1588168333986-5078d3ae3976?w=400&h=300&fit=crop",
        nutritional_info: {
          servingSize: { amount: 280, unit: "g" },
          calories: 580,
          macronutrients: {
            totalFat: { value: 38, unit: "g", saturatedFat: 12 },
            totalCarbohydrate: {
              value: 28,
              unit: "g",
              totalSugars: 6,
              dietaryFiber: 3,
            },
            protein: { value: 35, unit: "g" },
            sodium: { value: 720, unit: "mg" },
          },
          allergens: [],
          dietaryTags: ["gluten-free", "dairy-free"],
        },
      },
    ],
  },
  {
    id: "desserts",
    guid: "desserts-guid",
    name: "Desserts & Mignardises",
    order: 2,
    status: "active",
    color: "#8B4B8C",
    product_guids: [],
    product_ids: [],
    deleted_at: null,
    products: [
      {
        id: "chocolate-soufflé",
        name: "Valrhona Chocolate Soufflé",
        description:
          "Dark chocolate soufflé with raspberry coulis and vanilla bean ice cream",
        price: "24.00",
        weight: "180g",
        type: "food",
        item_type: "food" as const,
        status: "active",
        slug: "valrhona-chocolate-souffle",
        bundles: null,
        additional_info: null,
        special_price: null,
        is_custom: 0,
        deleted_at: null,
        extra_limit: null,
        product_limit: null,
        color: "#8B4B8C",
        sample_image:
          "https://images.unsplash.com/photo-1624353365286-3f8d62daad51?w=400&h=300&fit=crop",
        nutritional_info: {
          servingSize: { amount: 180, unit: "g" },
          calories: 385,
          macronutrients: {
            totalFat: { value: 22, unit: "g", saturatedFat: 14 },
            totalCarbohydrate: {
              value: 42,
              unit: "g",
              totalSugars: 30,
              dietaryFiber: 2,
            },
            protein: { value: 8, unit: "g" },
            sodium: { value: 180, unit: "mg" },
          },
          allergens: ["eggs", "milk", "gluten"],
          dietaryTags: ["vegetarian"],
        },
      },
    ],
  },
  {
    id: "beverages",
    guid: "beverages-guid",
    name: "Curated Beverages",
    order: 3,
    status: "active",
    color: "#1E3A8A",
    product_guids: [],
    product_ids: [],
    deleted_at: null,
    products: [
      {
        id: "champagne-krug",
        name: "Krug Grande Cuvée",
        description:
          "Prestige champagne with notes of brioche, honey, and citrus. Vintage blend.",
        price: "45.00",
        weight: "125ml",
        type: "drink",
        item_type: "drink" as const,
        status: "active",
        slug: "krug-grande-cuvee",
        bundles: null,
        additional_info: null,
        special_price: null,
        is_custom: 0,
        deleted_at: null,
        extra_limit: null,
        product_limit: null,
        color: "#1E3A8A",
        sample_image:
          "https://images.unsplash.com/photo-1558346490-a72e53ae2d4f?w=400&h=300&fit=crop",
        nutritional_info: {
          servingSize: { amount: 125, unit: "ml" },
          calories: 95,
          macronutrients: {
            totalFat: { value: 0, unit: "g" },
            totalCarbohydrate: {
              value: 2.5,
              unit: "g",
              totalSugars: 1.5,
              dietaryFiber: 0,
            },
            protein: { value: 0.1, unit: "g" },
            sodium: { value: 10, unit: "mg" },
          },
          allergens: ["sulfites"],
          dietaryTags: ["vegan", "gluten-free"],
        },
      },
    ],
  },
];
